module.exports = __webpack_public_path__ + "img/单车-点击业务.38482bc9.png";